import Vue from 'vue';
import VueAnalytics from 'vue-gtag';
import Router from '@/router';

import Brand from '@/services/Brand';

let brand = null;

switch ( Brand.getBrand() ) {
	case 'umia':
		brand = 'UA-175121925-1';
		break;

	case 'mmic':
		brand = 'UA-175114981-1';
		break;

	case 'amic':
		brand = 'UA-184653726-1';
		break;

	case 'rrg':
		brand = 'UA-211944839-1';
		break;

	default:
		break;
}

if (brand) {
	Vue.use(
		VueAnalytics,
		{
			config: {
				id: brand,
			},
		},
		Router,
	);
}
